// ORDER STEPS
export const _LOAN = 0;
export const _BORROWER = 1;
export const _APPOINTMENT = 2;
export const _PAYMENT = 3;

// for the CHECKOUT process
export const _CHECKOUTLOAN = 0;
export const _CHECKOUTPAYMENT = 1;

// Billing Workflows
export const PaymentTypePayNow = 1;
export const PaymentTypeDeferPayment = 2;
export const PaymentTypeMuellerInvoice = 3;

// Language
export const submitFailedMessage = "Please resolve your form errors before submitting, check for any red text or missing/required fields.";
export const purchaseAgreementCheckbox = "Purchase Agreement is not available at this time.";
export const purchaseAgreementDelays = "You may experience a delay in service if the appraiser does not have access to the purchase agreement when they begin to work on this assignment.";
export const purchaseAgreementDialog = "Please upload a purchase agreement. If you do not have a purchase agreement please check the box 'Purchase Agreement is not available'";

export const ExplainDeferPayment = "Explain how Borrower Credit Card payment operates.";
export const ExplainPayNow = "The following credit cards are accepted: Visa, MasterCard, Discover and American Express.";
export const ExplainMuellerInvoice = "This order will be invoiced per the terms in your contract agreement.";

export const RadioDeferPayment = "Send payment request to borrower";
export const RadioPayNow = "Pay now";
export const RadioMuellerInvoice = "Pay by Mueller Invoice"; 
